import type { BasicQuestionGroupDto, PagedRequestQuestionGroupDto, QuestionGroupDto, QuestionGroupInputDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class QuestionGroupService {
  apiName = 'Default';
  

  createQuestionGroupByInput = (input: QuestionGroupInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/question-group/question-group',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  deleteQuestionGroupByQuestionGroupId = (questionGroupId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/question-group/question-group/${questionGroupId}`,
    },
    { apiName: this.apiName,...config });
  

  editQuestionGroupByInputDto = (inputDto: QuestionGroupInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/question-group/edit-question-group',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllQuestionGroupActivesByIsCommon = (isCommon: boolean, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BasicQuestionGroupDto[]>({
      method: 'GET',
      url: '/api/app/question-group/question-group-actives',
      params: { isCommon },
    },
    { apiName: this.apiName,...config });
  

  getAllQuestionGroupsByInput = (input: PagedRequestQuestionGroupDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<QuestionGroupDto>>({
      method: 'GET',
      url: '/api/app/question-group/question-groups',
      params: { name: input.name, state: input.state, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getQuestionGroupByQuestionGroupId = (questionGroupId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, QuestionGroupDto>({
      method: 'GET',
      url: `/api/app/question-group/question-group/${questionGroupId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
